<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <div class="col">
            <h5 class="mb-4">
              <strong>{{ isEditingUser ? 'Editar' : 'Crear'}} usuario</strong>
            </h5>
          </div>
        </b-row>
        <b-form v-on:keydown.enter.prevent>
          <b-row>
            <div class="col-md-8">
              <b-row>
                <div class="col-md-6">
                  <b-form-group id="input-group-1">
                    <label for="input-1">Rol: <b style="color: red;">*</b></label>
                    <multiselect v-model="listRoles" :options="roles" :multiple="true" :taggable="true" label="text" track-by="value"
                      select-label="Presiona enter para seleccionar" deselect-label="Presiona enter para remover" selected-label="Seleccionado"
                      placeholder="Seleccione una opción" :disabled="isDisabledByRole">
                    </multiselect>
                  </b-form-group>
                </div>
                <div class="col-md-6" v-if="!isDisabledByRole">
                  <b-form-group id="input-group-2" :valid-feedback="validCC" :invalid-feedback="validCC">
                    <label for="input-2">Identificación: <b style="color: red;">*</b></label>
                    <b-form-input id="input-2" v-model="form.cc" placeholder="Ingrese el nip" onkeypress="return event.keyCode != 13;" :state="stateCC" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6" v-else>
                  <b-form-group id="input-group-2">
                    <label for="input-2">Identificación: <b style="color: red;">*</b></label>
                    <b-form-input id="input-2" v-model="form.cc" placeholder="Ingrese el nip" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group id="input-group-3">
                    <label for="input-3">Primer Nombre: <b style="color: red;">*</b></label>
                    <b-form-input id="input-3" v-model="form.firstName" placeholder="Ingrese el nombre" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group id="input-group-4" label="Segundo Nombre:" label-for="input-4">
                    <b-form-input id="input-4" v-model="form.secondName" placeholder="Ingrese el nombre" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group id="input-group-5">
                    <label for="input-5">Primer Apellido: <b style="color: red;">*</b></label>
                    <b-form-input id="input-5" v-model="form.firstLastName" placeholder="Ingrese el apellido" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group id="input-group-6" label="Segundo Apellido:" label-for="input-6">
                    <b-form-input id="input-6" v-model="form.secondLastName" placeholder="Ingrese el apellido" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group id="input-group-7" label="Email:" label-for="input-7">
                    <b-form-input id="input-7" v-model="form.email" placeholder="Ingrese el email" :disabled="isDisabledByRole"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-row>
                    <div class="col" v-if="listRoles.some((rol)=>rol.value==7)">
                      <b-form-group id="input-group-8" label="Grado:" label-for="input-8">
                        <b-form-select v-model="form.idGrade" :options="grades" :disabled="isDisabledByRole"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group id="input-group-9" label="Teléfono:" label-for="input-9">
                        <b-form-input id="input-9" v-model="form.phone" placeholder="Ingrese el númerico teléfonico" :disabled="isDisabledByRole"></b-form-input>
                      </b-form-group>
                    </div>
                  </b-row>
                </div>
                <div class="col-md-6">
                  <b-form-group id="input-group-10" label="Código de tarjeta:" label-for="input-10">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-pencil text-blue" /></span>
                      </div>
                      <b-form-input id="input-10" v-model="form.codeCard" placeholder="Código de tarjeta"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-md-6" v-if="hasPermission([consts.permissions.CREATE_USER])">
                  <b-form-group id="input-group-11" label="Saldo:" label-for="input-11">
                    <b-input-group>
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-money text-blue" /></span>
                      </div>
                      <b-form-input type="number" step="1" id="input-11" v-model="form.balance" placeholder="Saldo" :disabled="isEditingUser"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </div>
              </b-row>
            </div>
            <div class="col-md-4">
              <b-row class="justify-content-center">
                <img :src="form.pathAvatar"
                @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                width="175" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
                <div style="max-width:300px">
                  <b-form-file
                    @change="onFileChange"
                    placeholder="Seleccione una imagen"
                    drop-placeholder="Suelta la imagen aquí"
                    accept="image/jpeg, image/png, image/gif"
                    browse-text="Buscar imagen"
                    v-model="file"
                    :disabled="isDisabledByRole"
                  ></b-form-file>
                  <p class="text-secondary">La imagen no debe superar las 5MB</p>
                </div>
                <!-- <div class="custom-file">
                  <input type="file" class="custom-file-input" id="customFile" @change="onFileChange" enctype="multipart/form-data" lang="es">
                  <label class="custom-file-label" for="customFile">Buscar</label>
                </div> -->
                <!-- <input type="file" class="form-control-file" id="exampleFormControlFile1" @change="onFileChange" enctype="multipart/form-data"> -->
              </b-row>
              <b-row class="justify-content-center">
                <b-col align-self="center" style="text-align: center;" v-if="showRechargeType()">
                  <b-form-group class="mt-2" label="Tipo de recarga:" v-if="!isEditingUser">
                    <b-form-radio-group
                      v-model="form.typeToCharge"
                      :options="options"
                      value-field="item"
                      text-field="name"
                      disabled-field="notEnabled"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-row>
          <b-row v-if="form.isStudent">
            <div class="col-md-12">
              <b-collapse id="taggs-collapse" class="mt-2" v-model="form.isStudent">
                <b-row>
                  <b-col md="4">
                    <b-form-group>
                      <label>¿Quién es el acudiente? <b style="color: red;">*</b></label>
                      <b-form-select v-model="form.guardianWho" :options="guardianOptions" :disabled="isDisabledByRole"></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group id="input-group-madre" label="Agregar madre:" label-for="input-madre"
                    :valid-feedback="validMother">
                      <b-form-input id="input-madre" ref="codeMother" v-model="form.motherNIP" placeholder="Ingrese el NIP" onkeypress="return event.keyCode != 13;" :state="stateMother" :disabled="isDisabledByRole"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group id="input-group-padre" label="Agregar padre:" label-for="input-padre"
                    :valid-feedback="validFather">
                      <b-form-input id="input-padre" ref="codeFather" v-model="form.fatherNIP" placeholder="Ingrese el NIP" onkeypress="return event.keyCode != 13;" :state="stateFather" :disabled="isDisabledByRole"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4" v-if="form.guardianWho === '3'">
                    <b-form-group id="input-group-acudiente" label="Agregar acudiente:" label-for="input-acudiente"
                    :valid-feedback="validGuardian">
                      <b-form-input id="input-acudiente" ref="codeGuardian" v-model="form.guardianNIP" placeholder="Ingrese el NIP" onkeypress="return event.keyCode != 13;" :state="stateGuardian"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-collapse>
            </div>
          </b-row>
          <p class="mb-0"> <b style="color: red;">*</b> Campo obligatorio</p>
          <b-button @click="save()" variant="primary" class="mr-2 mb-3 mt-3" >{{ isEditingUser ? 'Guardar cambios' : 'Crear'}}</b-button>
          <router-link to="/users" class="btn mr-2 mb-3 mt-3 btn-light btn-sm">
            Cancelar e ir a lista
          </router-link>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import axios from 'axios'
import { mapState } from 'vuex'
import { isOnlyDigits, isEmail, hasPermission, consts, getRoleNameById, showErrorMessage } from '@/services/utilities'

export default {
  name: 'ManagementArea',
  data() {
    return {
      isEditingUser: false,
      file: null,
      image: null,
      fileUrl: '',
      options: [
        { item: '1', name: 'Efectivo' },
        { item: '2', name: 'Transferencia' },
      ],
      columns: [
        { key: 'cc', label: 'Código' },
        { key: 'lastName', label: 'Apellidos' },
        { key: 'name', label: 'Nombres' },
        { key: 'grade', label: 'Grado' },
        { key: 'balance', label: 'Saldo' },
        { key: 'actions', label: 'Acciones' },
      ],
      guardianOptions: [
        { value: null, text: 'Seleccione una opción' },
        { value: '1', text: 'Padre' },
        { value: '2', text: 'Madre' },
        { value: '3', text: 'Otro' },
      ],
      checkParents: false,
      validCC: '',
      stateCC: null,
      userChecked: null,
      validMother: '',
      validFather: '',
      validGuardian: '',
      timerId: 0,
      codeCard: '',
      form: {
        cc: '',
        type: null,
        firstName: '',
        secondName: '',
        firstLastName: '',
        secondLastName: '',
        email: '',
        phone: '',
        codeCard: '',
        balance: 0,
        typeToCharge: '',
        idGrade: null,
        roles: [],
        pathAvatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Placeholder_no_text.svg/1200px-Placeholder_no_text.svg.png',
        guardianWho: null,
        motherId: '',
        motherNIP: '',
        fatherId: '',
        fatherNIP: '',
        guardianId: '',
        guardianNIP: '',
      },
      roles: [],
      grades: [],
      listRoles: [],
      consts: consts,
    }
  },
  computed: {
    ...mapState(['user']),
    isDisabledByRole: function () {
      if (this.isEditingUser) {
        const onlyRoles = this.form.roles.map(r => r.name)
        if (this.user.id === this.form.id) {
          return false
        }
        if (this.user.role === getRoleNameById(consts.roles.ADMIN_RESTAURANTE)) {
          return !(onlyRoles.includes(getRoleNameById(consts.roles.RECARGADOR)) || onlyRoles.includes(getRoleNameById(consts.roles.CAJERO)) ||
            onlyRoles.includes(getRoleNameById(consts.roles.VISITANTE)))
        }
        if (this.user.role === getRoleNameById(consts.roles.GESTOR_ACADEMICO)) {
          return !(onlyRoles.includes(getRoleNameById(consts.roles.DOCENTE)) || onlyRoles.includes(getRoleNameById(consts.roles.ESTUDIANTE)) ||
          onlyRoles.includes(getRoleNameById(consts.roles.VISITANTE)) || onlyRoles.includes(getRoleNameById(consts.roles.PADRE_MADRE)))
        }
        if (this.user.role === getRoleNameById(consts.roles.ADMIN_ACADEMICO)) {
          return !(onlyRoles.includes(getRoleNameById(consts.roles.DOCENTE)) || onlyRoles.includes(getRoleNameById(consts.roles.ESTUDIANTE)) ||
            onlyRoles.includes(getRoleNameById(consts.roles.PADRE_MADRE)) || onlyRoles.includes(getRoleNameById(consts.roles.GESTOR_ACADEMICO)))
        }
        if (this.user.role === getRoleNameById(consts.roles.ADMIN)) {
          return false
        }
        return true
      }
      return false
    },
    invalidMother() {
      if (this.form.guardianWho !== '3' && this.form.motherNIP === '' && this.form.fatherNIP === '') {
        return 'El campo acudiente no debe estar vacío'
      }
      return 'No se encuentran coincidencias.'
    },
    invalidFather() {
      if (this.form.guardianWho !== '3' && this.form.fatherNIP === '' && this.form.motherNIP === '') {
        return 'El campo acudiente no debe estar vacío'
      }
      return 'No se encuentra coincidencias.'
    },
    invalidGuardian() {
      if (this.form.guardianWho === '3' && this.form.guardianNIP === '') {
        return 'El campo acudiente no debe estar vacío'
      }
      return 'No se encuentra coincidencias.'
    },
    stateMother: {
      get: function () {
        if (this.form.guardianWho !== '3' && this.form.motherNIP === '' && this.form.fatherNIP === '') {
          return false
        } else {
          return true
        }
      },
      set: function (state) {
        if (!state) {
          return false
        } else {
          return true
        }
      },
    },
    stateFather: {
      get: function () {
        if (this.form.guardianWho !== '3' && this.form.fatherNIP === '' && this.form.motherNIP === '') {
          return false
        } else {
          return true
        }
      },
      set: function (state) {
        if (!state) {
          return false
        } else {
          return true
        }
      },
    },
    stateGuardian: {
      get: function () {
        if (this.form.guardianWho === '3' && this.form.guardianNIP === '' && this.form.fatherNIP === '' && this.form.motherNIP === '') {
          return false
        } else {
          return true
        }
      },
      set: function (state) {
        if (!state) {
          return false
        } else {
          return true
        }
      },
    },
  },
  watch: {
    $route (to, from) {
      this.isEditingUser = typeof to.params.idUser !== 'undefined'
      if (!this.isEditingUser) {
        this.form = {
          cc: '',
          type: null,
          firstName: '',
          secondName: '',
          firstLastName: '',
          secondLastName: '',
          email: '',
          phone: '',
          codeCard: '',
          balance: 0,
          idGrade: null,
          roles: [],
          pathAvatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Placeholder_no_text.svg/1200px-Placeholder_no_text.svg.png',
          motherId: '',
          fatherId: '',
          guardianId: '',
          guardianWho: null,
          motherNIP: '',
          fatherNIP: '',
          guardianNIP: '',
        }
        this.file = null
        this.listRoles = []
      }
    },
    'form.cc': function(val) {
      if (val !== '') {
        this.debounce(val, 250, 4)
      } else {
        this.validCC = ''
        this.stateCC = null
      }
    },
    'form.motherNIP': function(val) {
      if (val !== '') {
        this.debounce(val, 250, 1)
      } else {
        this.validMother = ''
        this.stateMother = true
      }
    },
    'form.fatherNIP': function(val) {
      if (val !== '') {
        this.debounce(val, 250, 2)
      } else {
        this.validFather = ''
        this.stateFather = true
      }
    },
    'form.guardianNIP': function(val) {
      if (val !== '') {
        this.debounce(val, 250, 3)
      } else {
        this.validGuardian = ''
        this.stateGuardian = false
      }
    },
    listRoles: function(val) {
      if (val.some(check => check.value === 7)) {
        this.form.isStudent = true
      } else {
        this.form.isStudent = false
        this.stateMother = true
        this.stateFather = true
        this.stateGuardian = true
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    function getGrades() {
      return apiClient.get('/grades')
    }

    function getUser() {
      return apiClient2.get(`/users/${to.params.idUser}`, { params: { userProfile: true } })
    }

    if (to.params.idUser) {
      axios.all([getGrades(), getUser()])
        .then(axios.spread(function (grades, userEdit) {
          next((vm) => {
            vm.setDataGrades(null, grades.data.results.rows)
            vm.setDataUserEdit(null, userEdit.data.data)
          })
        }))
        .catch(err => {
          next((vm) => {
            vm.setDataGrades(err, [])
            vm.setDataUserEdit(err, [])
          })
        })
    } else {
      apiClient.get('/grades').then(response => {
        next(vm => vm.setDataGrades('', response.data.results.rows))
      }).catch(err => {
        next(vm => vm.setDataGrades(err, [])) // TODO Mostrar error
      })
    }
  },
  created() {
    function getRoles(list) {
      var rolesOptions = []
      list.map(e => {
        if (e === 1) {
          rolesOptions.push({ value: e, text: consts.rolesText.SU })
        }
        if (e === 2) {
          rolesOptions.push({ value: e, text: consts.rolesText.ADMIN })
        }
        if (e === 3) {
          rolesOptions.push({ value: e, text: consts.rolesText.ADMIN_ACADEMICO })
        }
        if (e === 4) {
          rolesOptions.push({ value: e, text: consts.rolesText.COORDINADOR })
        }
        if (e === 5) {
          rolesOptions.push({ value: e, text: consts.rolesText.GESTOR_ACADEMICO })
        }
        if (e === 6) {
          rolesOptions.push({ value: e, text: consts.rolesText.DOCENTE })
        }
        if (e === 7) {
          rolesOptions.push({ value: e, text: consts.rolesText.ESTUDIANTE })
        }
        if (e === 8) {
          rolesOptions.push({ value: e, text: consts.rolesText.PADRE_MADRE })
        }
        if (e === 9) {
          rolesOptions.push({ value: e, text: consts.rolesText.VISITANTE })
        }
        if (e === 10) {
          rolesOptions.push({ value: e, text: consts.rolesText.ADMIN_RESTAURANTE })
        }
        if (e === 11) {
          rolesOptions.push({ value: e, text: consts.rolesText.CAJERO })
        }
        if (e === 12) {
          rolesOptions.push({ value: e, text: consts.rolesText.RECARGADOR })
        }
        if (e === 13) {
          rolesOptions.push({ value: e, text: consts.rolesText.CONTADOR })
        }
        if (e === 14) {
          rolesOptions.push({ value: e, text: consts.rolesText.BIBLIOTECARIO })
        }
        if (e === 15) {
          rolesOptions.push({ value: e, text: consts.rolesText.FUNCIONARIO })
        }
        if (e === 16) {
          rolesOptions.push({ value: e, text: consts.rolesText.SUPERVISOR_RESTAURANTE })
        }
        if (e === 17) {
          rolesOptions.push({ value: e, text: consts.rolesText.PSICOLOGO })
        }
      })
      return rolesOptions
    }

    const roleCurrent = this.user.role
    if (roleCurrent === consts.rolesText.SU) {
      this.roles = getRoles([2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17])
    }
    if (roleCurrent === consts.rolesText.ADMIN) {
      this.roles = getRoles([2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17])
    }
    if (roleCurrent === consts.rolesText.ADMIN_ACADEMICO) {
      this.roles = getRoles([4, 5, 6, 7, 8, 17])
    }
    if (roleCurrent === consts.rolesText.ADMIN_RESTAURANTE) {
      this.roles = getRoles([9, 11, 12])
    }
    if (roleCurrent === consts.rolesText.GESTOR_ACADEMICO) {
      this.roles = getRoles([6, 7, 8, 9])
    }
    if (roleCurrent === consts.rolesText.RECARGADOR) {
      this.roles = getRoles([9])
    }
  },
  methods: {
    debounce: function(val, wait, type) {
      if (type === 4) {
        if (this.isEditingUser) {
          this.searchCC(val)
        } else {
          clearTimeout(this.timerId)
          this.timerId = setTimeout(() => {
            this.searchCC(val)
          }, wait)
        }
      } else {
        if (this.isEditingUser) {
          this.search(val, type)
        } else {
          clearTimeout(this.timerId)
          this.timerId = setTimeout(() => {
            this.search(val, type)
          }, wait)
        }
      }
    },
    showRechargeType() {
      this.form.typeToCharge = '1'
      return (this.form.balance > 0)
    },
    search(loadUser, type) {
      if (loadUser !== undefined) {
        apiClient2.get(`users?fields=id,cc,name,lastName,idGrade,balance,pathAvatar&page=0&per_page=10&q=cc!${loadUser}`).then(response => {
          if (response.data.data.rows.length > 0) {
            switch (type) {
              case 1:
                this.validMother = response.data.data.rows[0].fullName
                this.stateMother = true
                this.form.motherId = response.data.data.rows[0].id
                break
              case 2:
                this.validFather = response.data.data.rows[0].fullName
                this.stateFather = true
                this.form.fatherId = response.data.data.rows[0].id
                break
              case 3:
                this.validGuardian = response.data.data.rows[0].fullName
                this.stateGuardian = true
                this.form.guardianId = response.data.data.rows[0].id
                break
              default:
                console.log('error')
                break
            }
          } else {
            switch (type) {
              case 1:
                this.validMother = ''
                this.stateMother = false
                this.form.motherId = ''
                break
              case 2:
                this.validFather = ''
                this.stateFather = false
                this.form.fatherId = ''
                break
              case 3:
                this.validGuardian = ''
                this.stateGuardian = false
                this.form.guardianId = ''
                break
              default:
                console.log('error')
                break
            }
          }
        }).catch(e => {
          console.log(e)
          if (e.response.status === 401) {
            window.location = '/login'
          }
        })
      }
    },
    searchCC(userCC) {
      apiClient.get('/users/check-user/' + 1, { params: { cc: userCC } }).then(data => {
        if (data.data.state) {
          this.validCC = data.data.msg
          this.stateCC = data.data.state
        } else {
          if (this.isEditingUser && this.userChecked === null) {
            this.userChecked = data.data.user
          }
          this.validCC = data.data.msg
          this.stateCC = data.data.state
        }
        if (this.isEditingUser && this.userChecked.cc === userCC) {
          this.validCC = ''
          this.stateCC = true
        }
      })
    },
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    setDataGrades (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.grades = data.map(x => {
          return {
            value: x.id,
            text: 'COD' + x.id + ' - ' + x.name,
          }
        })
        this.grades.unshift({ value: null, text: 'Seleccione un grado' })
      }
    },
    setDataUserEdit (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.isEditingUser = true
        let formKeys = Object.keys(this.form)
        for (const key of formKeys) {
          if (data.user[key]) {
            if (key === 'pathAvatar') {
              this.form[key] = `${data.user[key]}`
            } else {
              this.form[key] = data.user[key]
            }
          }
        }
        this.form.id = data.user.id
        this.listRoles = data.user.roles.map((r) => {
          return {
            value: r.id,
            text: r.name,
          }
        })
        const userRoles = data.user.roles.map((e) => e.name)
        console.log(userRoles, consts.rolesText.ESTUDIANTE)
        if (userRoles.includes(consts.rolesText.ESTUDIANTE)) {
          formKeys = [
            ['idMother', 'motherId'], ['idFather', 'fatherId'], ['idGuardian', 'guardianId'],
            ['guardianWho', 'guardianWho'], ['motherNIP', ['mother', 'cc']], ['fatherNIP', ['father', 'cc']],
            ['guardianNIP', ['guardian', 'cc']],
          ]
          for (const key of formKeys) {
            if (data.userProfile[key[0]]) {
              this.form[key[1]] = data.userProfile[key[0]]
            } else {
              this.form[key[0]] = data.userProfile[key[1][0]]?.[key[1][1]]
            }
          }
        }
      }
    },
    onFileChange(e) {
      this.image = e.target.files[0]
      this.fileUrl = URL.createObjectURL(this.image)
      this.form.pathAvatar = this.fileUrl
    },
    save(evt) {
      if (evt) {
        evt.preventDefault()
      }
      this.form.cc = this.form.cc.trim()
      this.form.firstName = this.form.firstName.trim()
      this.form.secondName = this.form.secondName ? this.form.secondName.trim() : ''
      this.form.firstLastName = this.form.firstLastName.trim()
      this.form.secondLastName = this.form.secondLastName ? this.form.secondLastName.trim() : ''
      this.form.email = this.form.email.trim()
      this.form.codeCard = this.form.codeCard.trim()
      if (!this.form.balance) {
        this.form.balance = 0
      }

      if (this.listRoles.length < 1) {
        this.$notification.warning({
          message: 'Rol inválido',
          description: 'Seleccione el rol del usuario',
        })
        return
      }
      if (!this.form.cc || !isOnlyDigits(this.form.cc) || this.stateCC === false) {
        this.$notification.warning({
          message: 'cc inválido',
          description: 'El cc está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (!this.form.firstName) {
        this.$notification.warning({
          message: 'Nombre inválido',
          description: 'El nombre está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (!this.form.firstLastName) {
        this.$notification.warning({
          message: 'Apellido inválido',
          description: 'El apellido está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (this.form.email && !isEmail(this.form.email)) {
        this.$notification.warning({
          message: 'Email inválido',
          description: 'El Email/correo está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (this.form.idRole === 7 && !this.form.idGrade) {
        this.$notification.warning({
          message: 'Grado inválido',
          description: 'Seleccione el grado del usuario',
        })
        return
      }
      if (this.form.balance && !isOnlyDigits(this.form.balance)) {
        this.$notification.warning({
          message: 'Saldo de la tarjeta eroo inválido',
          description: 'El saldo de la tarjeta eroo está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (this.form.balance > 0 && !this.form.codeCard) {
        this.$notification.warning({
          message: 'No se ha ingresado el código de la tarjeta eroo',
          description: 'Para asignar saldo es necesario ingresar el códgio de la tarjeta',
        })
        return
      }
      if (this.findParents) {
        if (!(this.findParents && (((this.stateMother || this.stateFather) && this.guardianWho !== '3') || (this.stateGuardian && this.guardianWho === '3')))) {
          this.$notification.warning({
            message: 'Campos vacíos',
            description: 'Debes verificar los campos de los acudientes',
          })
          return
        }
      }
      if (!(this.user.role === consts.rolesText.SU || this.user.role === consts.rolesText.ADMIN || this.user.role === consts.rolesText.ADMIN_RESTAURANTE || this.user.role === consts.rolesText.RECARGADOR) && this.form.balance && !this.isEditingUser) {
        this.$notification.warning({
          message: 'No cuenta con los permisos suficientes para realizar esta operación',
          description: 'Su rol no le permite realizar cambios en el saldo.',
        })
        return
      }
      this.form.listRoles = this.listRoles.map((r) => r.value)

      if (this.isEditingUser) {
        if (this.isDisabledByRole) {
          apiClient.patch(`/users/${this.form.id}/code-card`, this.form).then(response => {
            this.$notification.success({
              message: 'Cambio guardado',
              description: 'El usuario ' + response.data.name + ' ' +
                    response.data.lastName + ' ha sido actualizado exitosamente.',
            })
            return this.saveImage(this.form.id) // Se retorna promesa
          }).catch(error => {
            this.$notification.error({
              message: 'Ooops ocurrió un error /n',
              description: showErrorMessage(error),
            })
          })
        } else {
          apiClient.put('/users/' + this.form.id, this.form).then(response => {
            this.form.fileUrl = `${response.data.pathAvatar}?tr=w-300`
            this.$notification.success({
              message: 'Cambio guardados',
              description: 'El usuario ' + response.data.name + ' ' +
                    response.data.lastName + ' ha sido actualizado exitosamente.',
            })
            return this.saveImage(this.form.id) // Se retorna promesa
          }).then(response => {
            if (response !== 'noFile') {
              this.$notification.success({
                message: 'Cambio guardados',
                description: 'Se actualizó la imagen de perfil exitosamente.',
              })
            }
          }).catch(error => {
            this.$notification.error({
              message: 'Ooops ocurrió un error /n',
              description: showErrorMessage(error),
            })
          })
        }
      } else {
        apiClient.post('/users', this.form).then(response => {
          this.$notification.success({
            message: 'Usuario creado',
            description: 'El usuario ' + response.data.name + ' ' +
                  response.data.lastName + ' ha sido creado exitosamente.',
          })
          this.form.id = response.data.id
          return this.saveImage(response.data.id) // Se retorna promesa
        }).then(response => {
          if (response !== 'noFile') {
            this.$notification.success({
              message: 'Cambio guardados',
              description: 'Se actualizó la imagen de perfil exitosamente.',
            })
          }
          this.$router.push({ name: 'usersEdit', params: { idUser: this.form.id } })
        }).catch(error => {
          this.$notification.error({
            message: 'Ooops ocurrió un error /n',
            description: showErrorMessage(error),
          })
        })
      }
    },
    saveImage(idUser) {
      if (this.file) { // Sube la foto de perfil
        if (this.file.size > 5000000) {
          return Promise.reject(new Error('La imagen tiene ' + (this.file.size / 1000000) + 'MB y no puede superar las 5MB'))
        }
        const formData = new FormData()
        formData.append('file', this.file)
        return apiClient.post('/users/' + this.form.id + '/profile-image',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
      } else {
        return new Promise((resolve, reject) => {
          resolve('noFile')
        })
      }
    },
    remove() { // Elimina un grado - Aun no implementado
      alert('Eliminado :D')
    },
    openModal(areaIn) { // Abre el modal para editar el grado
      this.areaToEdit = Object.assign({}, areaIn)
      this.$bvModal.show('edit-area')
    },
    edit(evt) { // Edita un grado llamando a la API
      evt.preventDefault()
      apiClient.patch(`/areas/${this.areaToEdit.id}`, this.areaToEdit).then(response => {
        this.data = this.data.map(x => (x.id === response.data.id) ? response.data : x)
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó el área ${response.data.name} correctamente.`,
        })
        this.$bvModal.hide('edit-area')
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrió un error /n',
          description: showErrorMessage(err),
        })
      })
    },
  },
}
</script>
